<template>
  <div v-if="document" class="col-xs-12 well">

    <div class="btn-group pull-left document-action">
      <span class="label label-internal" :style="cssProps">Internal Document</span>
    </div>
    <document-action :key="author.authorID+'-'+document.documentID+'-'+document.biblio" :document="document" :context="context" v-model="document.biblio"></document-action>
    <div class="clearfix"></div>
    <div class="row" style="margin-top: 10px">
      <div class="col-md-2 col-xs-12 col-sm-3 item-label">
        <span>Name : </span>
      </div>
      <div class="col-md-10 col-xs-12 col-sm-9">
        <span v-html="document.title"></span>
      </div>
    </div>
    <div class="row" style="padding-top: 10px">
      <div class="col-md-2 col-xs-12 col-sm-3 item-label">
        <span>Authors : </span>
      </div>
      <div class="col-md-10 col-xs-12 col-sm-9">
        <a class="coAuthors-divider" v-for="(coAuthor, key) in document.co_authors" v-bind:key="key">{{ coAuthor.lastName }} {{coAuthor.firstName }}</a>
      </div>
    </div>

    <div class="row" style="padding-top: 10px">
      <div class="col-md-2 col-xs-12 col-sm-3 item-label">
        <span>Affiliation :</span>
      </div>
      <div class="col-md-10 col-xs-12 col-sm-9">
        <template v-if="$user.isSe()">Schneider-Electric / repo4papers</template>
        <template v-if="$user.isBicWorld()">Bic - Confluence</template>
      </div>
    </div>

    <div class="row" style="padding-top: 10px">
      <div class="col-md-2 col-xs-12 col-sm-3 item-label">
        <span>Created : </span>
      </div>
      <div class="col-md-10 col-xs-12 col-sm-9">
        <span>{{ document.pubDate | moment('LLL')}}</span>
      </div>
    </div>

    <div class="row" style="padding-top: 15px">
      <div class="col-md-2 col-xs-12 col-sm-3 item-label">
        <span>Description : </span>
      </div>
      <div class="col-md-10 col-xs-12 col-sm-9 " style="line-height: 1.8">
        <span v-if="document.abstract" v-html="document.abstract"></span>
      </div>
    </div>

  </div>
</template>
<style scoped>

.label-internal {
  background-color: var(--color);
}

.item-label {
  font-weight: bold;
}
.coAuthors-divider + .coAuthors-divider:before {
  content: ", ";
}
.selected {
  border-left: 5px solid #34495e;
}
.provider-img {
  height: 25px;
}
</style>
<script>

import DocumentAction from './DocumentAction'
export default {
  name: 'InternalDocumentAuthor',
  components: {DocumentAction},
  props: ['value', 'author', 'context'],
  computed: {
    cssProps () {
      return {
        '--color': '#' + this.color
      }
    }
  },
  watch: {
    value: function (val) {
      this.document = val
    }
  },
  data () {
    return {
      document: null,
      color: '6a6c6f'
    }
  },
  beforeMount () {
    this.document = this.value

    this.color = this.$auth.user().profile.color_expert
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/InternalDocumentAuthor.vue